import { useRef, useState } from 'react'
import { InView } from 'react-intersection-observer'
import cn from 'classnames'
import Image from 'next/image'
// Components
import SearchBar from '@/components/search/Bar'
import Trustpilot from '@/components/trustpilot'
import s from './Hero.module.scss'

import springDesktop from 'public/home/peekaboo_puppies-spring.webp'
import springMobile from 'public/home/peekaboo_puppies-spring-mobile.webp'
import flowers from 'public/home/flowers.png'

type HeroProps = {
  // eslint-disable-next-line no-unused-vars
  setNewRoute: (key: string, value: string) => void
  isMobile: boolean
  isTablet: boolean
  isDiscountBannerClosed: boolean
}

export default function Hero({
  setNewRoute,
  isMobile,
  isTablet,
  isDiscountBannerClosed,
}: HeroProps) {
  /* SEARCH BAR BEHAVIOR */
  const [pinSearchBar, setPinSearchBar] = useState(false)
  const scrollRef = useRef(null)

  return (
    <InView className={s.hero} onChange={(b) => setPinSearchBar(!b)}>
      <div className={s.imageHeroContainer}>
        <div className={s.imageHeroBg}>
          {/* Flowers decorations */}
          <Image
            src={flowers}
            alt="flowers"
            height={280}
            width={360}
            quality={50}
            className={s.flower}
            style={{ right: '0' }}
            priority
          />
          <Image
            src={flowers}
            alt="flowers"
            height={280}
            width={360}
            quality={50}
            className={s.flower}
            style={{ left: '0', transform: 'scaleX(-1)' }}
            priority
          />
          <picture>
            <source srcSet={springMobile.src} media="(max-width: 767px)" />
            <Image
              src={springDesktop}
              alt="spring background"
              width={909}
              height={399}
              quality={50}
              priority
              className={cn(s.heroImage)}
              style={{ width: '100%', height: 'auto' }}
              fetchPriority="high"
            />
          </picture>
        </div>
      </div>

      <div className={s.bottom}>
        <h1>Find Your Perfect Puppy with Confidence</h1>
        <h2>
          Certified Breeders, Health Guarantees, and a Seamless Journey Trusted
          Nationwide
        </h2>

        <div
          ref={scrollRef}
          className={cn(s.searchBar, pinSearchBar ? s.pinned : s.unpinned)}
        >
          <SearchBar
            setNewRoute={setNewRoute}
            scrollRef={scrollRef}
            pinSearchBar={pinSearchBar}
            isTablet={isTablet}
            // Only needed for mobile
            isMobile={isMobile}
            isDiscountBannerClosed={isDiscountBannerClosed}
            isHome
            selectedZipcode=""
            selectedBreed={undefined}
            setSelectedBreed={undefined}
            selectedCategory={undefined}
            setShowNotificationForm={undefined}
          />
        </div>
        <div className={s.trustpilot}>
          <Trustpilot />
        </div>
      </div>
    </InView>
  )
}
